import customer from "./customer/customer";
import mycard from "./customer/mycard";
import mycoupon from "./customer/mycoupon";

import cashier from "./order/cashier";
import bookingorder from "./order/bookingorder";
import serviceorder from "./order/serviceorder";
import rechargeorder from "./order/rechargeorder";
import productorder from "./order/productorder";
import refundserviceorder from "./order/refundserviceorder";
import refundrechargeorder from "./order/refundrechargeorder";
import refundproductorder from "./order/refundproductorder";
import refundcardorder from "./order/refundcardorder";

import invoiceorder from "./order/invoiceorder";
import comment from "./order/comment";
import crossstoreorder from "./order/crossstoreorder";

import businessreport from "./report/businessreport";
import serviceorderreport from "./report/serviceorderreport";
import productorderreport from "./report/productorderreport";
import rechargeorderreport from "./report/rechargeorderreport";
import refundserviceorderreport from "./report/refundserviceorderreport";
import refundproductorderreport from "./report/refundproductorderreport";
import refundrechargeorderreport from "./report/refundrechargeorderreport";
import couponorderreport from "./report/couponorderreport";
import saleitemreport from "./report/saleitemreport";
import customersourcereport from "./report/customersourcereport";
import employeeperformance from "./report/employeeperformance";
import summaryadviserperformancereport from "./report/summaryadviserperformancereport";
import summarybeauticianperformancereport from "./report/summarybeauticianperformancereport";
import settlementdetailreport from "./report/settlementdetailreport";
import memberanalysisreport from "./report/memberanalysisreport";
import customerclassifyreport from "./report/customerclassifyreport";
import customerclassifydetailreport from "./report/customerclassifydetailreport";
import commentreport from "./report/commentreport";
import mycardreport from "./report/mycardreport";
import paymentreport from "./report/paymentreport";
import mycouponreport from "./report/mycouponreport";
import memberstatusreport from "./report/memberstatusreport";
import joinmemberstatusreport from "./report/joinmemberstatusreport";
import consumememberstatusreport from "./report/consumememberstatusreport";
import consumememberstatusinforeport from "./report/consumememberstatusinforeport";
import consumememberstatusgradereport from "./report/consumememberstatusgradereport";
import premiummemberreport from "./report/premiummemberreport";

import memberstatusdetailreport from "./report/memberstatusdetailreport";
import memberconsumetracereport from "./report/memberconsumetracereport";


import ordermonitor from "./safe/ordermonitor";

export default {
  customer: {
    customer: customer,
    mycard: mycard,
    mycoupon: mycoupon
  },
  order: {
    cashier: cashier,
    bookingorder: bookingorder,
    serviceorder: serviceorder,
    rechargeorder: rechargeorder,
    productorder: productorder,
    refundserviceorder: refundserviceorder,
    refundrechargeorder: refundrechargeorder,
    refundproductorder: refundproductorder,
    refundcardorder: refundcardorder,

    invoiceorder: invoiceorder,
    comment: comment,
    crossstoreorder: crossstoreorder
  },
  report: {
    businessreport: businessreport,
    serviceorderreport: serviceorderreport,
    productorderreport: productorderreport,
    rechargeorderreport: rechargeorderreport,
    refundserviceorderreport: refundserviceorderreport,
    refundproductorderreport: refundproductorderreport,
    refundrechargeorderreport: refundrechargeorderreport,
    couponorderreport: couponorderreport,
    saleitemreport: saleitemreport,
    customersourcereport: customersourcereport,
    employeeperformance: employeeperformance,
    summaryadviserperformancereport: summaryadviserperformancereport,
    summarybeauticianperformancereport: summarybeauticianperformancereport,
    settlementdetailreport: settlementdetailreport,
    memberanalysisreport: memberanalysisreport,
    commentreport: commentreport,
    customerclassifyreport: customerclassifyreport,
    customerclassifydetailreport:customerclassifydetailreport,
    mycardreport: mycardreport,
    paymentreport: paymentreport,
    mycouponreport: mycouponreport,
    memberstatusreport: memberstatusreport,
    joinmemberstatusreport: joinmemberstatusreport,
    consumememberstatusreport: consumememberstatusreport,
    consumememberstatusinforeport: consumememberstatusinforeport,
    consumememberstatusgradereport: consumememberstatusgradereport,
    premiummemberreport: premiummemberreport,

    memberstatusdetailreport: memberstatusdetailreport,
    memberconsumetracereport:memberconsumetracereport,
  },
  safe: {
    ordermonitor: ordermonitor
  }
  // menu:{
  //     menuclassify: menuclassify,
  //     menuitem: menuitem,
  //     storemenuitem:storemenuitem,
  // },
};



// WEBPACK FOOTER //
// ./src/api/ispa/index.js